import * as firmwareErrorCodes from '../../../consts/iot/firmwareErrorCodes';

export default class FwuDownloadUrlIsEmpty extends Error {
    constructor() {
        super();
        this.message = 'download_url is empty';
        this.code = firmwareErrorCodes.START_NOT_FOUND_DATA;
    }
}
